import { render } from "./TGUploadCheck.vue?vue&type=template&id=f20d8f02"
import script from "./TGUploadCheck.vue?vue&type=script&lang=js"
export * from "./TGUploadCheck.vue?vue&type=script&lang=js"

import "./TGUploadCheck.vue?vue&type=style&index=0&id=f20d8f02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__